<template>
  <li v-if="visible" class="context__menu-item">
    <a class="context__menu-item-link" @click="abrir">
      <i class="context__menu-item-icon iconoir-lock"></i>
      Permisos de la columna
    </a>
    <PermisosDeColumnaModal
      ref="modal"
      :field="field"
      :workspace-id="database.workspace.id"
    />
  </li>
</template>

<script>
/**
 * "Permisos de la columna" en el menú de cada columna. Ocupa el sitio del de
 * enterprise (mismo tipo en el registro), que salía a todos con candado. Este
 * sale solo a quien puede configurarla: el admin del espacio, o el Encargado
 * de la tabla o de su base si la columna no está en "solo admins". Quien
 * decide de verdad es el servidor (api/campos).
 */
import PermisosDeColumnaModal from '@extras_mg/components/PermisosDeColumnaModal'
import { EDITOR, nivelesQuePuedePoner, permisosDe } from '@extras_mg/utils/roles'

export default {
  name: 'PermisosDeColumnaItem',
  components: { PermisosDeColumnaModal },
  props: {
    field: { type: Object, required: true },
    table: { type: Object, required: true },
    database: { type: Object, required: true },
    view: { type: Object, default: null },
  },
  emits: ['hide-context'],
  computed: {
    visible() {
      // Una columna que se calcula sola no la escribe nadie: no hay qué decidir.
      const tipo = this.$registry.get('field', this.field.type)
      if (tipo.isReadOnly || tipo.isReadOnlyField(this.field)) return false
      const espacio = this.database.workspace.id
      const nivel =
        permisosDe(this.$store, espacio, 'mg_permisos_de_campo')?.niveles?.[
          this.field.id
        ] || EDITOR
      return (
        nivelesQuePuedePoner(
          permisosDe(this.$store, espacio, 'mg_roles'),
          this.database.id,
          this.table.id,
          nivel
        ).length > 0
      )
    },
  },
  methods: {
    abrir() {
      this.$refs.modal.show()
      this.$emit('hide-context')
    },
  },
}
</script>
